import { render, staticRenderFns } from "./m-product-short-info.vue?vue&type=template&id=35fb50c7&scoped=true&"
import script from "./m-product-short-info.vue?vue&type=script&lang=js&"
export * from "./m-product-short-info.vue?vue&type=script&lang=js&"
import style0 from "./m-product-short-info.vue?vue&type=style&index=0&id=35fb50c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb50c7",
  null
  
)

export default component.exports